import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Box,
} from '@mui/material';

import IdVerification from 'app/components/account_info/IdVerification';

const IdVerificationStep = ({
  afterCancel,
  idvStatus,
  idvDate,
}) => {
  if (idvStatus !== 'not_required') {
    document.location.href = '/advisor_signup/account_setup/idv';
    return null;
  }

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <IdVerification
          idv_status={idvStatus}
          idv_date={idvDate}
        />
        <Button variant="outlined" size="large" sx={{ mt: 2, maxWidth: '300px', width: '100%' }} onClick={afterCancel}>
          Cancel
        </Button>
      </Box>
    </Container>
  );
};

IdVerificationStep.propTypes = {
  afterCancel: PropTypes.func.isRequired,
  idvStatus: PropTypes.string.isRequired,
  idvDate: PropTypes.string.isRequired,
};

export default IdVerificationStep;
